/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { subscriptionDestroy } from '../../axios/subscriptionDestroy'
import type {
	SubscriptionDestroyError,
	SubscriptionDestroyPathParams,
	SubscriptionDestroyResponse,
} from '../../types/SubscriptionDestroy'

export const subscriptionDestroyMutationKey = () => [{ url: '/:organisation/profiles/:profile/subscription' }] as const

export type SubscriptionDestroyMutationKey = ReturnType<typeof subscriptionDestroyMutationKey>

export type SubscriptionDestroyVariables = {
	organisation: SubscriptionDestroyPathParams['organisation']
	profile: SubscriptionDestroyPathParams['profile']
}

/** @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::destroy */
export function useSubscriptionDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		SubscriptionDestroyResponse,
		AxiosError<SubscriptionDestroyError>,
		SubscriptionDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: subscriptionDestroyMutationKey(),
		mutationFn: ({ organisation, profile }: SubscriptionDestroyVariables) =>
			subscriptionDestroy(organisation, profile, config).then(res => res.data),
		...options,
	})
}
